import { Flex } from '@chakra-ui/react';
import BaseHero from '@components/features/landing-pages/BaseHero';
import SingleLineForm from '@components/interactive/SingleLineForm';
import isValidZipCode from '@utils/isValidZipCode';

const Hero = ({ goNext }) => {
  return (
    <BaseHero
      header="Find a Medicare Supplement Plan in Seconds"
      subheader="We’ll show you our favorite Medicare Supplements in your area including price estimates."
      renderCta={() => (
        <Flex w="100%" maxW="450px">
          <SingleLineForm
            type="tel"
            placeholder="Zip Code"
            buttonText="Continue"
            onSubmit={(zipCode) => goNext({ zipCode })}
            customValidate={(value: string) => !isValidZipCode(value) && 'Invalid Zip Code'}
          />
        </Flex>
      )}
    />
  );
};

export default Hero;
